// extracted by mini-css-extract-plugin
export default {"ManageColumnsButton":"OMc9m6AK3nIm3ZTeajQn"};